import { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";

const ChatSidebar = ({
  setShowCreateGroup,
  Users,
  CollapsibleSection,
  groups,
  activeUser,
  setActiveUser,
  admin,
  conversations,
  unreadMap,
  handleSelectUser,
  usersNotInInbox,
  filteredConnectedUsers
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const handleMobileUserSelect = (user) => {
    handleSelectUser(user);
    setIsOpen(false); // Close sidebar on mobile
  };

  // Handle group selection for mobile - close sidebar
  const handleMobileGroupSelect = (group) => {
    setActiveUser({ ...group, is_group: true });
    setIsOpen(false); // Close sidebar on mobile
  };

  // Handle connected user selection for mobile - close sidebar
  const handleMobileConnectedUserSelect = (user) => {
    setActiveUser({ ...user, is_group: false });
    setIsOpen(false); // Close sidebar on mobile
  };

const filteredGroups = !query?.trim() 
  ? groups || []  // Show all groups
  : groups?.filter(item => 
      item?.name?.toLowerCase().includes(query.toLowerCase())
    ) || [];

const filteredConversations = !query?.trim()
  ? conversations || []  
  : conversations?.filter(item => 
      item?.user_profile?.name?.toLowerCase().includes(query.toLowerCase())
    ) || [];

// Add source and merge
const mergedResults = [
  ...filteredGroups.map(item => ({ ...item, source: "group" })),
  ...filteredConversations.map(item => ({ ...item, source: "conversation" }))
];

// Filter by type
const groupsOnly = mergedResults.filter(item => item.source === "group");
const conversationsOnly = mergedResults.filter(item => item.source === "conversation");



  return (
    <>
      <div className="absolute top-[120px] right-8 md:hidden p-4">
        <button
          className="p-2 bg-gray-100 text-black  rounded-full text-white rounded-[10px]"
          onClick={() => setIsOpen(true)}
        >
          <FiMenu className="" />
        </button>
      </div>
      
      <div
        className={`fixed md:static top-30 left-0 h-full w-full max-w-[350px] border-r border-gray-100 p-4 min-h-full overflow-y-auto bg-white z-50 transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
        }`}
      >
        {/* Header with create group button */}
        <div className="mb-6">
          <div className="flex gap-2 items-center justify-between">
           <input
  type="text"
  placeholder="Search groups,profile..."
  value={query}
  onChange={(e) => setQuery(e.target.value)}
  className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
/>

            <button
              className="flex items-center justify-center w-10 h-10 bg-[#e8f0f7] rounded-full cursor-pointer hover:bg-[#d0e0f0] transition-all duration-200 shadow-sm hover:shadow"
              onClick={() => setShowCreateGroup(true)}
              title="Create Group"
              aria-label="Create Group"
            >
              <Users size={20} className="stroke-[#0f6abf]" />
            </button>
          </div>
        </div>

        {/* Groups Section */}
        <div className="mb-8">
          <div className="conversation-list group-list">
            <CollapsibleSection title="Groups" defaultOpen={true}>
              <div className="space-y-1 mt-2">
                {groupsOnly.map((group) => (
                  <div
                    key={group.id || group.conversationId}
                    className={`flex items-center p-3 rounded-xl cursor-pointer transition-all duration-200 ${
                      activeUser?.id === group.id 
                        ? "bg-[#e8f0f7] ring-1 ring-[#0f6abf]/20" 
                        : "hover:bg-gray-50"
                    }`}
                    onClick={() => {
                      // Use mobile handler for mobile, original for larger screens
                      if (window.innerWidth < 768) {
                        handleMobileGroupSelect(group);
                      } else {
                        setActiveUser({ ...group, is_group: true });
                      }
                    }}
                  >
                    <div className="relative flex-shrink-0">
                      <img
                        src={group.profile_image || admin}
                        className="w-10 h-10 rounded-lg object-cover ring-gray-100"
                        alt={group.name}
                      />
                    </div>
                    <div className="ml-3 flex-1 min-w-0">
                      <h4 className="font-medium text-sm text-gray-900 truncate">{group.name}</h4>
                      <p className="text-xs text-gray-500 truncate">Group • {group.member_count || 0} members</p>
                    </div>
                  </div>
                ))}
              </div>
            </CollapsibleSection>
          </div>
        </div>

        {/* Inbox Section */}
        <div className="mb-8">
          <div className="chat-sidebar-section">
            <CollapsibleSection title="Inbox" defaultOpen={true}>
              <div className="space-y-1 mt-2">
                {conversationsOnly.map((conv) => {
                  const user = conv.user_profile;
                  if (!user) return null;
                  const unread = unreadMap[user.id] || 0;
                  return (
                    <div
                      key={conv.id}
                      className={`flex items-center p-3 rounded-xl cursor-pointer transition-all duration-200 relative ${
                        activeUser?.id === user.id 
                          ? "bg-[#e8f0f7] ring-1 ring-[#0f6abf]/20" 
                          : unread > 0 
                            ? "bg-gray-50" 
                            : "hover:bg-gray-50"
                      }`}
                      onClick={() => {
                        // Use mobile handler for mobile, original for larger screens
                        if (window.innerWidth < 768) {
                          handleMobileUserSelect(user);
                        } else {
                          handleSelectUser(user);
                        }
                      }}
                    >
                      <div className="relative flex-shrink-0">
                        <img
                          src={user.profile_picture || admin}
                          className="w-10 h-10 rounded-lg object-cover ring-1 ring-gray-100"
                          alt={user.name}
                        />
                        {unread > 0 && (
                          <div className="absolute -top-1 -right-1 w-5 h-5 bg-[#0f6abf] rounded-full flex items-center justify-center">
                            <span className="text-xs text-white font-medium">{unread}</span>
                          </div>
                        )}
                      </div>
                      <div className="ml-3 flex-1 min-w-0">
                        <div className="flex items-center justify-between">
                          <h4 className="font-medium text-sm text-gray-900">{user.name}</h4>
                          {conv.timestamp && (
                            <span className="text-xs text-gray-500">{conv.timestamp}</span>
                          )}
                        </div>
                        <div className="flex items-center justify-between mt-0.5">
                          <p className="text-xs text-gray-600 truncate max-w-[160px]">
                            {conv.message?.trim() ? conv.message : "No messages yet"}
                          </p>
                          {conv.is_online && (
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </CollapsibleSection>
          </div>
        </div>

        {/* Connected Users Section */}
        <div className="chat-sidebar-section">
          {usersNotInInbox.length > 0 && (
            <CollapsibleSection title="Connected Users" defaultOpen={true}>
              <div className="space-y-1 mt-2">
                {filteredConnectedUsers.map((connection) => {
                  const user = connection.user_profile;
                  if (!user) return null;
                  return (
                    <div
                      key={connection.id}
                      className={`flex items-center p-3 rounded-xl cursor-pointer transition-all duration-200 ${
                        activeUser?.id === user.id 
                          ? "bg-[#e8f0f7] ring-1 ring-[#0f6abf]/20" 
                          : "hover:bg-gray-50"
                      }`}
                      onClick={() => {
                        // Use mobile handler for mobile, original for larger screens
                        if (window.innerWidth < 768) {
                          handleMobileConnectedUserSelect(user);
                        } else {
                          setActiveUser({ ...user, is_group: false });
                        }
                      }}
                    >
                      <div className="relative flex-shrink-0">
                        <img
                          src={user.profile_picture || admin}
                          className="w-10 h-10 rounded-lg object-cover ring-1 ring-gray-100"
                          alt={user.name}
                        />
                        <div className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 rounded-full ring-1 ring-white"></div>
                      </div>
                      <div className="ml-3 flex-1 min-w-0">
                        <h4 className="font-medium text-sm text-gray-900">{user.name}</h4>
                        <p className="text-xs text-gray-500">Online</p>
                      </div>
                      <button className="ml-2 p-1.5 rounded-lg hover:bg-gray-100 transition-colors">
                        <span className="text-xs font-medium text-[#0f6abf]">Message</span>
                      </button>
                    </div>
                  );
                })}
              </div>
            </CollapsibleSection>
          )}
        </div>

        {isOpen && (
          <button
            className="absolute top-4 right-16 md:hidden p-3 bg-[#D0E0F0] rounded-full text-white rounded-full"
            onClick={() => setIsOpen(false)}
          >
            <FiX />
          </button>
        )}
      </div>
    </>
  );
};

export default ChatSidebar;